(() => {
  function calculate(variant, quantity, planId, volumeEnabled) {
    const qty = Math.max(1, Math.trunc(Number(quantity) || 1));
    const plan = variant.plans.find(item => String(item.id) === String(planId));
    if (planId && !plan) return null;
    const percent = !plan && volumeEnabled ? (qty >= 6 ? 20 : qty >= 3 ? 15 : qty >= 2 ? 5 : 0) : 0;
    const subtotal = (plan ? plan.price : variant.price) * qty;
    const total = subtotal - Math.round(subtotal * percent / 100);
    const reference = Math.max(variant.compare || 0, variant.price) * qty;
    return { total, reference, savings: Math.max(0, reference - total), percent, subscription: !!plan };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = calculate;
  if (typeof customElements === 'undefined' || customElements.get('vivetus-purchase-price')) return;
  customElements.define('vivetus-purchase-price', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-vv-price-data]').textContent);
      this.scope = this.closest('capsules-purchase, powder-purchase, product-info') || this.parentElement;
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency', currency:this.dataset.currency});
      this.schedule = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.update(), 0); };
      this.scope.addEventListener('change', this.schedule);
      this.scope.addEventListener('input', this.schedule);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.schedule();
      });
      this.observer.observe(this.scope, {subtree:true, childList:true, attributes:true, attributeFilter:['value','checked']});
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.schedule);
      this.scope?.removeEventListener('input', this.schedule);
    }
    update() {
      const form = this.scope.querySelector('form[action*="/cart/add"]');
      const id = form?.querySelector('[name="id"]')?.value || this.data.initialVariant;
      const variant = this.data.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const quantity = this.scope.querySelector('[name="quantity"]:checked')?.value || this.scope.querySelector('input[name="quantity"][type="number"]')?.value || 1;
      const planId = form?.querySelector('[name="selling_plan"]:not(:disabled)')?.value || '';
      const result = calculate(variant, quantity, planId, this.data.volumeEnabled);
      if (!result) { this.hidden = true; return; }
      this.hidden = false;
      this.querySelector('[data-vv-total]').textContent = this.money.format(result.total / 100);
      const compare = this.querySelector('[data-vv-compare]');
      compare.hidden = !result.savings;
      compare.textContent = this.money.format(result.reference / 100);
      const saving = this.querySelector('[data-vv-saving]');
      saving.hidden = !result.savings;
      saving.textContent = this.data.labels.save.replace('__AMOUNT__', this.money.format(result.savings / 100));
      this.querySelector('[data-vv-detail]').textContent = result.subscription ? this.data.labels.subscription : result.percent ? this.data.labels.volume.replace('__PERCENT__', result.percent) : '';
    }
  });
})();
